import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetchAll(farm, date) {
        const options = {
            method: 'get',
            url: `/umbraco/api/VehicleRegister/get?farm=${farm}&date=${date}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchByType(farm, vehicleType) {
        const options = {
            method: 'get',
            url: `/umbraco/api/VehicleRegister/getbytype?farm=${farm}&vehicleType=${vehicleType}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
     fetchActive(farm) {
        const options = {
            method: 'get',
            url: `/umbraco/api/VehicleRegister/getactive?farm=${farm}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSingle(farmId, id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/VehicleRegister/getsingle?farmId=${farmId}&id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    duplicate(farmId, vehicleId, vehicleType) {

        const options = {
            method: 'get',
            url: `/umbraco/api/VehicleRegister/Duplicate?farmId=${farmId}&vehicleId=${vehicleId}&vehicleType=${vehicleType}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchLatestCheckList(farmId, vehicleId) {

        const options = {
            method: 'get',
            url: `/umbraco/api/VehicleRegister/GetCheckListResponse?farmId=${farmId}&vehicleId=${vehicleId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    updateStatus(vehicleRegister) {

        const options = {
            method: 'put',
            url: `/umbraco/api/VehicleRegister/UpdateStatus`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: vehicleRegister
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    delete(farmId, id) {

        const options = {
            method: 'delete',
            url: `/umbraco/api/VehicleRegister/delete?farmId=${farmId}&id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    transfer(vehicleIdNum, oldFarmId, newFarmId) {

        const options = {
            method: 'post',
            url: `/umbraco/api/VehicleRegister/transfer?vehicleIdNum=${vehicleIdNum}&oldFarmId=${oldFarmId}&newFarmId=${newFarmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    add(vehicleRegister) {

        const options = {
            method: 'post',
            url: `/umbraco/api/VehicleRegister/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: vehicleRegister
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    checklist(vehicleChecklist) {

        const options = {
            method: 'post',
            url: `/umbraco/api/VehicleRegister/CheckList`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: vehicleChecklist
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    update(vehicleRegister) {

        const options = {
            method: 'put',
            url: `/umbraco/api/VehicleRegister/Update`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: vehicleRegister
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    uploadImage(image, id) {

        const options = {
            method: 'post',
            url: `/umbraco/api/VehicleRegister/UploadImageToVehicleCheckList?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: image
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    createMedia(image) {

        const options = {
            method: 'post',
            url: `/umbraco/api/VehicleRegister/CreateMedia`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: image
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}